module.exports = __webpack_public_path__ + "static/media/AI-recipe-generator.ee267ed7.png";